import { render, staticRenderFns } from "./content_serviceHall.vue?vue&type=template&id=25b2f046"
import script from "./content_serviceHall.vue?vue&type=script&lang=js"
export * from "./content_serviceHall.vue?vue&type=script&lang=js"
import style0 from "./content_serviceHall.vue?vue&type=style&index=0&id=25b2f046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports